import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagFacturacionConIGV = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagFacturacionConIGV'>
      {({ field }) => (
        <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagFacturacionConIGV' label='Facturacion con IGV' />
      )}
    </Field>
  )
}

export default React.memo(FlagFacturacionConIGV)
